module.exports = __webpack_public_path__ + "static/media/sign-in-background-om.3957ee33.png";